import { Typography } from '@navi/web-ui/lib/primitives';
import { STATUS_CONFIG } from '../../utils';

const StatusBanner = ({ status }: { status?: string }) => {
  if (!status || !STATUS_CONFIG[status]) return null;

  const config = STATUS_CONFIG[status];

  return (
    <div
      className="flex flex-row justify-center items-center w-full h-[28px]"
      style={{ backgroundColor: config.bgColor }}
    >
      <Typography variant="h5" color={config.textColor}>
        {config.label}
        {config.suffix && (
          <>
            {'\u00A0'}
            <Typography as="span" variant="p5" color={config.suffixColor}>
              {config.suffix}
            </Typography>
          </>
        )}
      </Typography>
    </div>
  );
};

export default StatusBanner;
